import serviceSubscription from '@/api/service-subscription'
import feeType from '@/api/fee-type'
import student from '@/api/student-profile'
import feeSetup from '@/api/fee-setup'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return serviceSubscription.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store (context, data) {
    return serviceSubscription.store(data)
  },
  destroy (context, { studentId, feeSetupId }) {
    return serviceSubscription.destroy(studentId, feeSetupId)
  },
  getFeeType (context, attrubutes = {}) {
    return feeType.get({ params: attrubutes })
  },
  getStudent (context, attrubutes = {}) {
    return student.get({ params: attrubutes })
  },
  getFeeSetup (context, attrubutes = {}) {
    return feeSetup.get({ params: attrubutes })
  },
  fetchStudentSubscript (context, attrubutes = {}) {
    return serviceSubscription.get({ params: attrubutes })
  }
}
